import { getAppName as getAppNameNew } from '@atlassian/teams-common/context-config';

export enum AppNames {
	EMBEDDABLE_DIRECTORY = 'embeddableDirectory',
	STANDALONE_DIRECTORY = 'standaloneDirectory',
}

/**
 * @private
 * @deprecated use getAppName from `@atlassian/teams-common/context-config` instead
 */
export function getAppName(): AppNames {
	return getAppNameNew();
}
